<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="headerText">路由总览</span>
    </div>
    <div class="">
      <el-tree
        :data="list"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
      >
        <span slot-scope="{ node }" class="custom-tree-node">
          <span>{{ node.label }}</span>
          <div>
            <span>{{ node.data.currentUrl.substr(1) }} </span>
            <span
              v-clipboard:copy="node.data.currentUrl.substr(1)"
              v-clipboard:success="clipboardSuccess"
              class="copy"
            >复制</span>
          </div>
        </span>
      </el-tree>
    </div>
  </el-card>
</template>
<script>
// import router from '@/router'
export default {
  name: 'RouterList',

  data() {
    return {
      list: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created() {},
  mounted() {
    this.list = this.$router.options.routes
    this.getTree(this.list, '')
  },
  methods: {
    clipboardSuccess() {
      this.$msg('复制成功', 'success')
    },
    getTree(list, parentPath) {
      list.forEach(el => {
        el.currentUrl = parentPath + '/' + el.path
        el.label = el.meta && el.meta.title
        if (el.children) {
          this.getTree(el.children, el.currentUrl)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped >
  .box-card{
    width:20rem;
    margin:2rem  auto
    .headerText{
      color: rgb(105, 178, 253);
      font-size: 20px
    }
    .copy{
      margin-left: 1rem;
      color:#69b2fd
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }

</style>
